import { render, staticRenderFns } from "./SettlementGovernment.vue?vue&type=template&id=12759d9c&"
import script from "./SettlementGovernment.vue?vue&type=script&lang=js&"
export * from "./SettlementGovernment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports